'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsEthernet = function MdSettingsEthernet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.6 9.1l9.1 10.9-9.1 10.9-2.6-2.1 7.3-8.8-7.3-8.7z m-11.2 12.5v-3.2h3.2v3.2h-3.2z m10-3.2v3.2h-3.4v-3.2h3.4z m-16.8 3.2v-3.2h3.4v3.2h-3.4z m1.4-10.3l-7.3 8.7 7.3 8.8-2.6 2.1-9.1-10.9 9.1-10.9z' })
        )
    );
};

exports.default = MdSettingsEthernet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-ethernet.js
// module id = 1948
// module chunks = 168707334958949